@if (commissionerData; as commissioner) {
    <div class="accordion-container">
        <cll-card-divider />
        <div class="accordion-row-field">
            <app-accordion-item [label]="'Commissioner reference'" [data]="commissioner.reference"/>
        </div>
        <div class="accordion-row-field">
            <app-accordion-item [label]="'Commissioner name'" [data]="commissioner.name"/>
        </div>
        <div class="accordion-row-field">
            <app-accordion-item [label]="'Send alert if packages are accepted without any documents attached'"
                                [data]="commissioner.mandatory_documents ? 'Yes' : 'No'"/>
        </div>

        @if (commissioner.status){
            <cll-card-footer>
                <button cll-tonal-button (click)="editGeneralInformation()">
                    <cll-icon cllButtonIcon type="outlined" [size]="20">edit</cll-icon>
                    Edit
                </button>
            </cll-card-footer>
        }
    </div>
}
